// contexts/AuthContext.jsx
import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Verificar si hay un admin logueado al cargar
    const storedAdmin = localStorage.getItem('admin');
    if (storedAdmin) {
      setAdmin(JSON.parse(storedAdmin));
    }
    setLoading(false);
  }, []);

  const login = (username, password) => {
    // Usuario hardcodeado con más información
    if (username === 'admin' && password === '123456') {
      const adminData = {
        id: 1,
        username: 'admin',
        nombre: 'Administrador',
        email: 'admin@centralpasajes.com',
        role: 'Administrador',
        avatar: null // Para futura implementación de avatar
      };
      localStorage.setItem('admin', JSON.stringify(adminData));
      setAdmin(adminData);
      return true;
    }
    return false;
  };

  const logout = () => {
    localStorage.removeItem('admin');
    setAdmin(null);
  };

  return (
    <AuthContext.Provider
      value={{
        admin,
        loading,
        login,
        logout
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};